var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuivi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "#20ACE3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.55562 19.2207H8.77771C9.08451 19.2207 9.33333 19.4693 9.33333 19.7761V25.3317C9.33333 25.6386 9.08451 25.8874 8.77771 25.8874H6.55562C6.24882 25.8874 6 25.6386 6 25.3317V19.7761C6 19.4693 6.24882 19.2207 6.55562 19.2207Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1023 14.7793H14.3246C14.6314 14.7793 14.8802 15.0281 14.8802 15.3349V25.3349C14.8802 25.6417 14.6314 25.8905 14.3246 25.8905H12.1023C11.7955 25.8905 11.5469 25.6417 11.5469 25.3349V15.3349C11.5469 15.0281 11.7955 14.7793 12.1023 14.7793Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6728 17H19.8951C20.2019 17 20.4505 17.2488 20.4505 17.5556V25.3333C20.4505 25.6401 20.2019 25.889 19.8951 25.889H17.6728C17.366 25.889 17.1172 25.6401 17.1172 25.3333V17.5556C17.1172 17.2488 17.366 17 17.6728 17Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2197 13.666H25.4418C25.7486 13.666 25.9974 13.9148 25.9974 14.2216V25.3327C25.9974 25.6395 25.7486 25.8883 25.4418 25.8883H23.2197C22.9129 25.8883 22.6641 25.6395 22.6641 25.3327V14.2216C22.6641 13.9148 22.9129 13.666 23.2197 13.666Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3333 7C23.4133 7.00102 22.6677 7.74666 22.6667 8.66667C22.6689 8.84814 22.701 9.028 22.7619 9.19889L19.9807 10.8521C19.6157 10.465 19.0865 10.2774 18.5592 10.348C18.0317 10.4186 17.5706 10.7388 17.3202 11.2084L14.8672 9.99337C14.8792 9.92196 14.8863 9.84994 14.889 9.77771C14.8902 9.10307 14.4847 8.49434 13.8617 8.23535C13.2388 7.97656 12.5212 8.11877 12.0441 8.59566C11.5668 9.07255 11.4242 9.78992 11.6828 10.4131L8.50081 12.7878C8.24854 12.6374 7.96045 12.5573 7.66667 12.5556C6.74626 12.5556 6 13.3017 6 14.2223C6 15.1427 6.74626 15.889 7.66667 15.889C8.58708 15.889 9.33333 15.1427 9.33333 14.2223C9.33191 14.0217 9.29407 13.8233 9.22164 13.6364L12.4353 11.2379C13.064 11.5884 13.8481 11.4857 14.3651 10.9848L17.1546 12.3664C17.3405 13.1947 18.12 13.7505 18.9637 13.6565C19.8074 13.5625 20.4454 12.849 20.4444 12C20.4444 11.9577 20.435 11.9178 20.432 11.8763L23.4569 10.078C23.7191 10.2438 24.0229 10.3323 24.3333 10.3333C25.2537 10.3333 26 9.58708 26 8.66667C26 7.74626 25.2537 7 24.3333 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuivi);
export default __webpack_public_path__ + "static/media/suivi.cb7630887b8dd671ba3225607a83f80d.svg";
export { ForwardRef as ReactComponent };